import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { CartProvider } from "./context/CartContext";
import Nav from "./components/Nav";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Shop from "./pages/Shop";
import ProductDetail from "./pages/ProductDetail";
import Packages from "./pages/Packages";
import Cart from "./pages/Cart";
import Installation from "./pages/Installation";
import Brands from "./pages/Brands";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Admin from "./pages/Admin";
import PaymentSuccess from "./pages/PaymentSuccess";
import PaymentCancel from "./pages/PaymentCancel";
import BankDetails from "./pages/BankDetails";
import Quote from "./pages/Quote";
import DesignPreview from "./pages/DesignPreview";
import ReturnPolicy from "./pages/ReturnPolicy";
import Consultation from "./pages/Consultation";
import WhatsappFab from "./components/WhatsappFab";
import "@/App.css";

export default function App() {
  return (
    <CartProvider>
      <BrowserRouter>
        <div className="App min-h-screen flex flex-col">
          <Nav />
          <main className="flex-1">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/shop" element={<Shop />} />
              <Route path="/shop/:category" element={<Shop />} />
              <Route path="/product/:id" element={<ProductDetail />} />
              <Route path="/packages" element={<Packages />} />
              <Route path="/brands" element={<Brands />} />
              <Route path="/installation" element={<Installation />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/quote" element={<Quote />} />
              <Route path="/design-preview" element={<DesignPreview />} />
              <Route path="/return-policy" element={<ReturnPolicy />} />
              <Route path="/consultation" element={<Consultation />} />
              <Route path="/cart" element={<Cart />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/payment/success" element={<PaymentSuccess />} />
              <Route path="/payment/cancel" element={<PaymentCancel />} />
              <Route path="/payment/bank-details" element={<BankDetails />} />
            </Routes>
          </main>
          <Footer />
          <Routes>
            <Route path="/admin" element={null} />
            <Route path="*" element={<WhatsappFab />} />
          </Routes>
          <Toaster theme="light" position="top-right" toastOptions={{ style: { background: "#FFFFFF", border: "1px solid rgba(166,124,0,0.35)", color: "#0F0F0F" } }} />
        </div>
      </BrowserRouter>
    </CartProvider>
  );
}
